import BaseController from "../../controller/BaseController";
import AdminDataService from "../../util/AdminDataService";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import Validator from "../../util/Validator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class LeaveTypesController extends BaseController {
    private readonly DIALOG_ID = "DialogCreateUpdateLeaveType";

    public async onInit(): Promise<void> {
        AdminDataService.getLeaveTypes();
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onCreateLeaveType(): Promise<void> {
        this.getView().setModel(new JSONModel({
            isSpecialType: false,
        }), "leaveType");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onEdit(oEvent: Button$PressEvent): Promise<void> {
        const selectedLeaveType = oEvent.getSource().getBindingContext("dataModel");
        this.getView().setModel(new JSONModel(selectedLeaveType.getObject()), "leaveType");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onSaveDialog(oEvent: Dialog$AfterCloseEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        const leaveTypeData = (this.getView().getModel("leaveType") as JSONModel).getData();

        if (leaveTypeData.id) {
            AdminDataService.updateLeaveType(leaveTypeData);
        } else {
            AdminDataService.createLeaveType(leaveTypeData);
        }

        this.destroyDialog(this.DIALOG_ID);
    }
}